export default __webpack_public_path__ + "static/media/cancelar_suscripcion.505aa634.png";